import { Input } from "antd"
import style from "./NameSection.module.scss"

const { section, labelRow, label, requiredMark, textInput } = style

type Props = {
	value: string
	onChange: (value: string) => void
	onBlur?: () => void
	/** `Mixed` in the batch panel (REQ-403), where the selected objects hold different names. */
	placeholder?: string
}

export const NameSection = ({ value, onChange, onBlur, placeholder }: Props) => {
	return (
		<div className={section}>
			<div className={labelRow}>
				<span className={label}>Name</span>
				<span className={requiredMark}>*</span>
			</div>
			<Input
				className={textInput}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				onBlur={onBlur}
				placeholder={placeholder}
				maxLength={255}
				aria-label="Name"
			/>
		</div>
	)
}
